import { defineMessages } from 'react-intl';

export default defineMessages({
  unit: {
    id: 'unit',
    description: 'unit',
    defaultMessage: 'unit',
  },
  units: {
    id: 'units',
    description: 'units',
    defaultMessage: 'units',
  },
  requestSubmittedString: {
    id: 'requestSubmitted',
    description: 'Request submitted for',
    defaultMessage: 'Request submitted for',
  },
  darUpdateString: {
    id: 'darUpdate',
    description: 'DAR will update',
    defaultMessage:
      'Your DAR should be updated with your submitted order in the next 24hrs.',
  },
  backToDashboardString: {
    id: 'backToDashboard',
    description: 'back to dashboard',
    defaultMessage: 'Back to Dashboard',
  },
});
